var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AuthenticatedLayout',[_c('h2',[_vm._v("Deals")]),_vm._v(" "),_c('div',{staticClass:"w-full",attrs:{"id":"chart_container"}},[_c('trading-vue',{ref:"chart",attrs:{"id":"chart_container","type":"candles","width":2000,"color-back":"#ffffff","color-grid":"#eee","color-text":"#333","timezone":3,"titleTxt":"MA","data":_vm.data_chart}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }